"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auditBookingReturn = auditBookingReturn;
exports.backOffBookingReturn = backOffBookingReturn;
exports.bookingReturnPage = bookingReturnPage;
exports.confirmBookingReturn = confirmBookingReturn;
exports.getReturnInfo = getReturnInfo;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var baseUrl = '/xyGaBookingOrderReturn';

// 预定单退单表分页
function bookingReturnPage(query) {
  return (0, _requestPIM.default)({
    url: baseUrl + '/page',
    method: 'get',
    params: query
  });
}

// 获取单个退款单信息
function getReturnInfo(data) {
  return (0, _requestPIM.default)({
    url: baseUrl + '/getReturnInfo',
    method: 'post',
    data: {
      returnId: data
    }
  });
}

// 审核退款申请
function auditBookingReturn(data) {
  return (0, _requestPIM.default)({
    url: baseUrl + '/audit',
    method: 'post',
    data: data
  });
}

// 确认退款（财务操作）
function confirmBookingReturn(data) {
  return (0, _requestPIM.default)({
    url: baseUrl + '/confirm',
    method: 'post',
    data: data
  });
}

// 回退退款状态
function backOffBookingReturn(data) {
  return (0, _requestPIM.default)({
    url: baseUrl + '/backOff',
    method: 'post',
    data: data
  });
}